import React, { useState } from 'react';

import PropTypes from 'prop-types';
import Box from '@tds/core-box';
import TextArea from '@tds/core-text-area';
import Button from '@tds/core-button';
import Spinner from '@tds/core-spinner';

import request from '../../../../../../../utils/request';
import { useLocalizedStringsContext } from '../../../../../../../context/LocalizedStringsContext';

const AddComment = ({ orderData, setNewCommentAdded }) => {
  const {
    ORDERS: { save }
  } = useLocalizedStringsContext();

  const [comment, setComment] = useState();
  const [uploadingComment, setUploadingComment] = useState(false);

  const onAddComment = async () => {
    try {
      const { id } = orderData;
      setComment('');
      setUploadingComment(true);
      const result = await request.post(`/orders/${id}/comments`, {
        text: comment
      });
      if (result) {
        setUploadingComment(false);
        setNewCommentAdded(result.data.id);
      }
    } catch (err) {
      setUploadingComment(false);
    }
  };
  return (
    <Box between={4}>
      <TextArea
        label=""
        id="order-comment"
        value={comment}
        onChange={e => setComment(e.target.value)}
      />
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Spinner
          label="Posting comment..."
          size="small"
          spinning={uploadingComment}
          inline
        >
          <Button variant="secondary" onClick={onAddComment}>
            {save}
          </Button>
        </Spinner>
      </div>
    </Box>
  );
};

AddComment.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.any).isRequired,
  setNewCommentAdded: PropTypes.func.isRequired
};

export default AddComment;
